// Vite exposes import.meta.env.VITE_* at build time. Validate the surface
// we use so a missing var fails loudly at boot instead of as a 404 later.

const apiUrl = import.meta.env.VITE_API_URL ?? 'http://localhost:3001';

if (!/^https?:\/\//.test(apiUrl)) {
  throw new Error(
    `VITE_API_URL must be a full http(s) URL (got "${apiUrl}"). Add VITE_API_URL=… to .env.local.`,
  );
}

// The MCP endpoint founders paste into their AI tool. Defaults to the api,
// and is its own variable so it can move to a dedicated host (mcp.magig.app,
// the convention Stripe/Linear/Notion follow) without a code change. Must
// match the api's MCP_PUBLIC_URL exactly — it is the same identifier, and a
// client binds its token to it.
// Typed at the read rather than inferred: import.meta.env's index signature
// is `any`, so without this the value stays `any` all the way into MCP_URL and
// every use of it is unchecked.
const mcpUrlRaw = import.meta.env['VITE_MCP_URL'] as string | undefined;
const mcpUrl: string = mcpUrlRaw ?? `${apiUrl}/mcp`;

if (!/^https?:\/\//.test(mcpUrl)) {
  throw new Error(`VITE_MCP_URL must be a full http(s) URL (got "${mcpUrl}").`);
}

export const env = {
  API_URL: apiUrl,
  MCP_URL: mcpUrl.replace(/\/$/, ''),
} as const;
